module.exports = "/* .list1 {\r\n    margin: 1px -15px 5px -15px;\r\n} */"


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance-menu/finance-menu.component.css
// module id = ./src/app/finance/finance-menu/finance-menu.component.css
// module chunks = main